import React, { useEffect } from "react";
import TradingViewWidget from "./TradingViewWidget.jsx";
import Watchlist from "./Watchlist.jsx";
import {
  ContainerMain,
  WatchListContainer,
  TradingViewContainer,
} from "./LiveChartElement.jsx";

export function LiveChart(props) {
  useEffect(() => {
    props.fetchHealth();
  }, [props]);

  return (
    <ContainerMain>
      <TradingViewContainer>
        <TradingViewWidget style={{ height: "100vh" }} />
      </TradingViewContainer>
      <WatchListContainer>
        <Watchlist />
      </WatchListContainer>
    </ContainerMain>
  );
}
